import {
  useGridMenuItem,
  type CustomMenuItemProps,
} from '@mint-lib/ag-grid/react';
import type { ComponentType, FC, SVGProps } from 'react';

import {
  itemVariants,
  Label,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import type { UserTableV2Row } from '../datasource.js';

export type MenuItemParams = {
  IconComponent: ComponentType<SVGProps<SVGSVGElement>>;
  color?: 'primary' | 'error' | 'warning';
};

type Props = Omit<CustomMenuItemProps<UserTableV2Row>, 'menuItemParams'> & {
  menuItemParams: MenuItemParams;
};

const MenuItem: FC<Props> = ({
  name,
  disabled,
  shortcut,
  cssClasses,
  menuItemParams: { IconComponent, color = 'primary' },
}) => {
  useGridMenuItem({
    configureDefaults: () => true,
  });

  return (
    <button
      type="button"
      className={cn(
        itemVariants({ popoverItem: 'default' }),
        'align-center !flex w-70 gap-2',
        cssClasses,
      )}
      disabled={disabled}
    >
      <IconComponent
        className={cn(typographyVariants({ color }), 'h-4 w-4 fill-current')}
      />
      <Label
        className="flex-1 shrink-0 grow cursor-[inherit]"
        variant="bodyShort01"
        color={color}
      >
        {name}
      </Label>
      {shortcut ? (
        <Label
          className="cursor-[inherit]"
          variant="bodyShort01"
          color="secondary"
        >
          {shortcut}
        </Label>
      ) : null}
    </button>
  );
};

export default MenuItem;
